module.exports = __webpack_public_path__ + "static/media/logo.e38f12a3.png";